import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserMenu from './UserMenu';
import NotificationBell from '../components/NotificationBell';
import './HeaderWithSearch.css';

const HeaderWithSearch: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="header-with-search">
      <div className="header-row">
        <div
          className="logo"
          onClick={() => navigate('/')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              navigate('/');
            }
          }}
        >
          <img
            src="/Gimbiya.png"
            alt="Gimbiya"
            className="logo-image"
          />
        </div>

        <div className="header-actions">
          <NotificationBell />
          <UserMenu />
        </div>
      </div>
    </div>
  );
};

export default HeaderWithSearch;